import React from "react";

export const DownTrendIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-2.5 h-1.5 text-red-50",
    ...props
}) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none" className={className} {...props}>
            <path d="M9.5 5.5L5.3 1.3L3.7 3.7L0.5 0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.5 5.5H9.5V3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};


export const UpTrendIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-2.5 h-1.5 text-green-50",
    ...props
}) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none" className={className} {...props}>
            <path d="M9.5 0.5L5.3 4.7L3.7 2.3L0.5 5.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.5 0.5H9.5V2.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};